import { render } from "./DebugPage.vue?vue&type=template&id=30227325&scoped=true"
import script from "./DebugPage.vue?vue&type=script&lang=js"
export * from "./DebugPage.vue?vue&type=script&lang=js"

import "./DebugPage.vue?vue&type=style&index=0&id=30227325&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30227325"]])

export default __exports__